import { useSelector } from 'react-redux';
import { getReportState } from '../../selectors/report';
import { EReportStatus } from '../../constants/report';

export const useIsReportStatusFinished = () => {
  const { reportStatus } = useSelector(getReportState);

  return reportStatus === EReportStatus.Finished;
};
